import { apiFetch } from '../../api/api';

// 🔹 GET all devices
export const getDevicesLive = () =>
  apiFetch("/api/printmanager/devices/live");

// 🔹 GET one device
export const getDeviceDetail = (deviceId) =>
  apiFetch(`/api/printmanager/devices/${deviceId}`);

export const setDeviceActivation = (deviceId, isActive) =>
  apiFetch(`/api/printmanager/devices/${encodeURIComponent(deviceId)}/activation`, {
    method: "PATCH",
    body: { isActive },
  });

// 🔹 POST unclaim
export const unclaimDevice = (deviceId) =>
  apiFetch(`/api/printmanager/devices/${deviceId}/unclaim`, {
    method: "POST",
  });

export const testPrint = (deviceId, printerId) =>
  apiFetch("/api/printmanager/test-print", {
    method: "POST",
    body: { deviceId, printerId },
  });

export const setDeviceOrg = (deviceId, orgId) =>
  apiFetch(`/api/printmanager/devices/${deviceId}/set-org`, {
    method: "POST",
    body: { orgId },
  });
